<template>
  <div
    class="base-toast-root"
    :style="{ '--toast-accent-color': stripeColor }"
  >
    <div class="base-toast-header">
      <div class="base-toast-icon">
        <i
          :class="icon"
          :style="{ color: iconColor }"
        ></i>
      </div>
      <div class="base-toast-title text-gray-dark bold-font">
        {{ title }}
      </div>
      <button
        class="base-toast-close"
        @click="$emit('close')"
        type="button"
        aria-label="Cerrar notificación"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="base-toast-body medium-font text-sm!">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    stripeColor: string;
    icon: string;
    iconColor: string;
    title: string;
  }>();

  defineEmits<{
    close: [];
  }>();
</script>

<style scoped lang="scss">
  @use '@/app/assets/sass/fonts' as *;

  .base-toast-root {
    background: var(--color-white);
    border-radius: 12px;
    box-shadow:
      0 4px 20px rgba(0, 0, 0, 0.08),
      0 1px 3px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    width: 360px;
    max-width: calc(100vw - 32px);
    min-height: 64px;
    position: relative;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: var(--toast-accent-color);
      z-index: 1;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow:
        0 8px 30px rgba(0, 0, 0, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.06);
    }

    @media (max-width: 601px) {
      width: calc(100vw - 32px);
      border-radius: 12px;
    }
  }

  .base-toast-header {
    display: flex;
    align-items: center;
    padding: 16px 20px 2px;
    gap: 12px;

    @media (max-width: 601px) {
      padding: 12px 16px 2px;
      gap: 10px;
    }
  }

  .base-toast-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--toast-icon-bg, var(--color-teal-lightest-2));
    flex-shrink: 0;

    @media (max-width: 601px) {
      width: 28px;
      height: 28px;
      border-radius: 6px;
    }
  }

  .base-toast-icon .fas {
    font-size: 14px;
    font-weight: 600;
  }

  .base-toast-title {
    font-size: 14px;
    flex: 1;
  }

  .base-toast-close {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: var(--color-gray-mid-2);
    flex-shrink: 0;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: var(--color-gray-dark);
    }

    &:active {
      transform: scale(0.95);
    }

    .fas {
      font-size: 12px;
    }
  }

  .base-toast-body {
    padding: 0 10px 16px 64px;

    @media (max-width: 601px) {
      padding: 0 8px 12px 54px;
      font-size: 13px;
    }
  }

  .base-toast-body :deep(*) {
    color: var(--color-gray-dark);
    margin: 0;
  }
</style>
